import React, { ReactElement } from "react";
import { AppDialPadButton } from "./AppDialPadButton";

export type DialPadButton = number | string;

interface Props {
  onClickButton: (button: number | string) => void;
}

export function AppDialPad(props: Props): ReactElement {
  const buttons = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [null, 0, "backwards"],
  ];

  return (
    <div className="AppDialPad">
      {buttons.map((row, rowIndex) => (
        <div className="AppDialPadRow" key={rowIndex.toString()}>
          {row.map((button, buttonIndex) => (
            <AppDialPadButton
              key={buttonIndex}
              onClick={() => (button !== null ? props.onClickButton(button) : null)}
            >
              {button}
            </AppDialPadButton>
          ))}
        </div>
      ))}
    </div>
  );
}
